import Link from 'next/link';
import Router from 'next/router';
import React from 'react';

// TODO: Add react-sizes to Auto-Collapse Mobile and expand otherwise
class AlphabeticData extends React.Component {
	constructor(props) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.state = { collapse: true };
	}

	toggle() {
		if (this.props.collapsable) {
			this.setState({ collapse: !this.state.collapse });
		}
	}

	render() {
		const { data, keyName } = this.props;

		return (
			<div className="category-elements-group letter-specific">
				<div className="category-elements-wrapper" id={keyName}>
					<div className="key-container">
						<h3 className="group-title">{keyName}</h3>
					</div>

					<div className="elements-container">
						{data.map((item, i) => (
							<div
								key={i}
								className="category-element"
								onClick={() =>
									Router.push(
										`/category/[categoryid]?categoryid=${
											item.urlRedirect != null ? item.urlRedirect : item.urlSlug
										}`,
										`/category/${item.urlRedirect != null ? item.urlRedirect : item.urlSlug}`
									).then(() => window.scrollTo(0, 0))
								}>
								<Link
									href={`/category/[categoryid]`}
									as={`/category/${item.urlRedirect != null ? item.urlRedirect : item.urlSlug}`}>
									<a href={`/category/${item.urlSlug}`}>
										<h5
											data-hover="size 06">
											{item.name}
										</h5>
									</a>
								</Link>
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}
}

export default AlphabeticData;
